import toDateFn, { dateParamType as dateParam } from './toDate'

export type dateParamType = dateParam
export default toDateFn
